import React from "react"
import Div100vh from "react-div-100vh"
import {
  Content,
  Holder,
  LeftHolder,
  Logo,
  LogoHolder,
  RightHolder,
  Title,
  Desc,
  ListHolder,
  Item,
  List,
  ItemTitle,
  Desc2,
  Pic,
  PicHolder
} from "./Specification.style.js"

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  type: "spring",
  stiffness: 150,
  damping: 50,
  mass: 1.2
}

export default function Specification() {
  return (
    <Div100vh>
      <Holder
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
      >
        <LeftHolder>
          <LogoHolder>
            <Logo src="assets/images/landing/logo.svg" />
          </LogoHolder>
          <Content>
            <Title>SPECIFICATION</Title>
            <Desc>
              The specification at Coronation Square gives you a unique
              opportunity to select which colour palette you prefer for your
              kitchen and bathroom. Choose from between the light and dark
              palettes and put your own stamp on your new home.
            </Desc>
            <Desc>
              The information below shows the intended specification for each of
              the homes available at Coronation Square. Everything has been
              professionally designed and thoughtfully chosen to maximise space
              and light.
            </Desc>
            <ListHolder>
              <List>
                <ItemTitle>KITCHEN</ItemTitle>
                <Item>
                  Nobilia fitted kitchen units, laminate worktop and full-height
                  splashback
                </Item>
                <Item>Integrated appliances</Item>
                <Item>
                  Siemens stainless steel built-under single oven or double oven
                  built in tall housing
                </Item>
                <Item>Siemens ceramic hob</Item>
                <Item>Integrated extractor hood</Item>
                <Item>Zanussi Fridge/Freezer</Item>
                <Item>Zanussi Dishwasher</Item>
                <Item>Zanussi Washer/Dryer*</Item>
                <Item>Soft close doors/drawers</Item>
                <Item>Under wall unit lighting</Item>
                <Item>Handle lighting</Item>
                <Item>
                  Franke composite sink with 1.5 bowl in black or grey and
                  Franke tap
                </Item>
              </List>
              <List>
                <ItemTitle>BATHROOMS</ItemTitle>
                <Item>White sanitaryware throughout with 180 litre bath</Item>
                <Item>Chrome mixer tap to wash hand basins</Item>
                <Item>
                  Thermostatic shower, bath screen and full-height tiling to
                  bath
                </Item>
                <Item>Half-height tiling to all walls</Item>
                <Item>
                  Thermostatic shower and full height tiling to shower enclosure
                  in en suite
                </Item>
                <Item>Wall mirror included to main bathroom</Item>
                <Item>Tiled flooring</Item>
                <Item>Extractor fan</Item>
                <Item>
                  Shaver socket to en suite or main bathroom (if no en suite)
                </Item>
                <Item>Chrome heated towel rail to bathroom and en suite</Item>
              </List>
              <List>
                <ItemTitle>ELECTRICAL</ItemTitle>
                <Item>
                  Satin chrome downlighters to kitchen/living area, bathrooms,
                  en suites and cloakrooms
                </Item>
                <Item>
                  Energy-efficient pendant ceiling lights to all other rooms
                </Item>
                <Item>USB charge point to kitchen double socket**</Item>
                <Item>Satin chrome switches throughout</Item>
                <Item>
                  Multi-socket media plate to living room (specific provider to
                  be connected by purchaser)
                </Item>
                <Item>
                  TV and telephone point to bedroom 1(specific provider to be
                  connected by purchaser)
                </Item>
                <Item>Mains operated smoke detector with battery backup</Item>
                <Item>Mechanical extract ventilation to selected plots†</Item>
                <Item>Balcony downlight</Item>
              </List>
              <List>
                <ItemTitle>DOORS AND WINDOWS</ItemTitle>
                <Item>Timber front entrance door with multi-point lock</Item>
                <Item>Aluminium double glazed windows with security locks</Item>
                <Item>Video door entry system</Item>
              </List>

              <List>
                <ItemTitle>HEATING</ItemTitle>
                <Item>
                  Central district heating system – no gas to individual
                  dwellings
                </Item>
                <Item>
                  Underfloor heating through out with the exception to bathrooms
                  and en suites
                </Item>
              </List>
              <List>
                <ItemTitle>INTERNAL FINISHES</ItemTitle>
                <Item>White painted internal doors with chrome furniture</Item>
                <Item>Soft white painted walls and smooth white ceilings</Item>
                <Item>
                  White painted mouldings including skirting boards, architraves
                  and window boards
                </Item>
              </List>
              <List>
                <ItemTitle>FLOORING</ItemTitle>
                <Item>Abingdon essential carpet to bedrooms</Item>
                <Item>
                  Amtico Spacia to all other areas, (with the exception to
                  bedrooms and bathrooms)
                </Item>
              </List>
              <List>
                <ItemTitle>WARDROBES</ItemTitle>
                <Item>
                  1300mm wardrobe with glazed sliding doors to bedroom 1
                  (location as shown in brochure)††
                </Item>
              </List>
            </ListHolder>
            <Desc2>
              NB Flow restrictors included to reduce water consumption. Standard
              specifications are correct at time of going to print, but are
              subject to change without notice. Please contact the sales
              executive for further information. *Located within hall cupboard
              to certain plots. Please speak to a sales executive for further
              information. **Standard sitting, no surge protection. †Please
              refer to the sales executive for specific details. ††Size is
              approximate, variations do occur due to layout restrictions. These
              are the only options available and are subject to stage of
              construction. We will not be able to accommodate any changes to
              the specification or layout other than the options available.
              Options are correct at time of going to print, but are subject to
              plot size. Please speak to a sales executive for further details.
              Images are of the light specification and are of the light colour
              palette. Image may include optional upgrades at additional cost.
              Issue 1: September 2021.
            </Desc2>
          </Content>
        </LeftHolder>
        <RightHolder>
          <PicHolder>
            <Pic src="assets/images/specs/1.jpg" />
            <Pic src="assets/images/specs/2.jpg" />
          </PicHolder>
        </RightHolder>
      </Holder>
    </Div100vh>
  )
}
